
import { FilterPersistence } from '../../api/filter/filter_persistence';
import {
  SnippetIndex,
  SnippetIndexFilters,
  SnippetIndexOptions,
} from '../../api/snippets/index';
import { Snippet } from '../../api/snippets/snippet';

import Vue from 'vue';

export default Vue.component('snippets', {
  data() {
    return {
      filters: {
        key_cont: ''
      } as SnippetIndexFilters,
      headers: [
        { text: 'Key', value: 'key' },
        { text: 'Last Updated', value: 'updatedAt' },
        { value: 'view', sortable: false, filterable: false },
      ],
      loading: true,
      loadingText: 'Loading Data...',
      snippetsCount: -1,
      snippets: [] as Snippet[],
      options: {} as SnippetIndexOptions
    };
  },
  mounted() {
    this.loadFilters();
    this.refreshTable();
  },
  methods: {
    refreshTable() {
      this.loading = true;

      this.options.filters = this.filters;

      SnippetIndex.getData(this.options).then((response) => {
        this.snippets = SnippetIndex.parseResponse(response.data.data);
        this.snippetsCount = response.data.count;
        this.loading = false;
      });
    },
    search() {
      this.options.page = 1;

      this.refreshTable();
    },
    maybeSearch(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        FilterPersistence.saveFieldFilterState(
          this.$router,
          'snippets',
          this.filters,
        );
        this.search();
      }
    },
    loadFilters() {
      const filter = FilterPersistence.getFieldFiltersFromUrl(this.$route);
      if (!filter) {
        return;
      }
      this.filters = filter;
    },
  },
  watch: {
    options: {
      handler() {
        this.refreshTable()
      },
      deep: true,
    },
  },
  computed: {
    superAdminMode: function () {
      let params = new URLSearchParams(document.location.search);
      return params.get("sam") === 'true';
    }
  }
});
